module.exports = {"id":"203159","name":"Tim Kister","rating":"71","photo":"./data/images/photos/4/203159.png","club":{"name":"SV Sandhausen","logo":"./data/images/clubs/SVSandhausen.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimKister0.json
// module id = 4130
// module chunks = 0